import * as ReactService from "@intech/react-service";
import { ContratoEntidade } from "../entidades/ContratoEntidade";
import { EmprestimoParametros } from "../entidades/EmprestimoParametros";
import { ConcessaoEntidade } from "../entidades/ConcessaoEntidade";
import { EmprestimoSimulacaoParametros } from "../entidades/EmprestimoSimulacaoParametros";
import { ContratoDisponivelEntidade } from "../entidades/ContratoDisponivelEntidade";
import { EmprestimoContratarParametros } from "../entidades/EmprestimoContratarParametros";

class Emprestimo extends ReactService.BaseService {
  constructor() {
    super("Emprestimo");
  }

  Buscar = (quantidade: number) =>
    this.CreateRequest<ContratoEntidade[]>(ReactService.RequestType.GET, `Buscar/${quantidade}`);

  BuscarDetalhePorNumeroAno = (numero: string, ano: string) =>
    this.CreateRequest<ContratoEntidade>(ReactService.RequestType.GET, `BuscarDetalhePorNumeroAno/${numero}/${ano}`);

  BuscarParametros = () =>
    this.CreateRequest<EmprestimoParametros>(ReactService.RequestType.GET, `BuscarParametros`);

  BuscarContratosReformar = (dataCredito: string) =>
    this.CreateRequest<ContratoEntidade[]>(ReactService.RequestType.GET, `BuscarContratosReformar/${dataCredito}`);

  CalcularConcessao = (parametros: EmprestimoSimulacaoParametros) =>
    this.CreateRequest<ConcessaoEntidade>(ReactService.RequestType.POST, `CalcularConcessao`, parametros);

  BuscarPrestacoes = (parametros: EmprestimoSimulacaoParametros) =>
    this.CreateRequest<ContratoDisponivelEntidade[]>(ReactService.RequestType.POST, `BuscarPrestacoes`, parametros);

  GerarToken = (enviarEmail: boolean, enviarSMS: boolean) =>
    this.CreateRequest<any>(ReactService.RequestType.POST, `GerarToken/${enviarEmail}/${enviarSMS}`);

  Contratar = (parametros: EmprestimoContratarParametros) =>
    this.CreateRequest<any>(ReactService.RequestType.POST, `Contratar`, parametros);

}

export const EmprestimoService = new Emprestimo();
